// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"8b8669e2","218":"8c225646","244":"d636c7e4","268":"d9895d68","364":"ed00e4a0","476":"040acbbf","524":"711d89f4","577":"f96b6f96","779":"f0fbcadd","896":"9ef2abdd","951":"c9fbb037","983":"598c9a53"}[chunkId] + ".chunk.js";
};